import { ChangeEvent, useState } from 'react';
import { Site } from 'src/models/site';
import TabContent from './TabContent';
import { WidgetThemesProps } from './types/pointsWidgetstypes';
import { TabButton, TabHeader, TabPanel, TabsContainer } from 'src/components/ui/Tabs';

interface PointsTabsProps {
  widgetSections: WidgetThemesProps;
  site: Site;
  readPoints: () => void;
  lastUpdated: string;
}

const PointsTabs = ({ widgetSections, site, readPoints, lastUpdated }: PointsTabsProps) => {
  const [tabValue, setTabValue] = useState(0);
  const { id: siteId } = site;

  const handleTabChange = (_: ChangeEvent<{}>, newValue?: number) => {
    if (newValue !== undefined) {
      setTabValue(newValue);
    }
  };

  return (
    <>
      <TabsContainer>
        <TabHeader value={tabValue} onChange={handleTabChange}>
          {Object.keys(widgetSections).map((theme) => (
            <TabButton key={theme} label={theme} />
          ))}
        </TabHeader>
        {Object.keys(widgetSections).map((theme, index) => (
          <TabPanel value={tabValue} index={index}>
            <TabContent
              sectionsWidgets={widgetSections[theme].sections}
              title={theme}
              time={lastUpdated}
              readPoints={readPoints}
              siteId={siteId}
            />
          </TabPanel>
        ))}
      </TabsContainer>
    </>
  );
};

export default PointsTabs;
